module.exports = __webpack_public_path__ + "img/replay.e10d0828.svg";